const NotFoundStyle = {
        NotFound: {
            paddingTop: "100px",
            textAlign: "center"
        }
};

export default NotFoundStyle;